export const btnProps = (attributes, isBackend = false) => {
	const { actionType = 'link', url, tooltip, tooltipPos = 'top', target, attrs = { rel: 'noreferrer', referrerpolicy: 'no-referrer' }, isDownload, downloadFileName = '', animationType, animationDuration, addID } = attributes;

	const hrefProps = url ? { href: url } : {};
	const downloadProps = isDownload ? { download: downloadFileName } : {};
	const linkProps = 'popup' === actionType || isBackend ? {} : { ...hrefProps, target, ...attrs, ...downloadProps };
	const tooltipProps = { tooltip, 'tooltip-pos': tooltipPos }
	const animationProps = {
		'data-aos': animationType,
		// 'data-aos-offset': 100,
		// 'data-aos-delay': 50,
		'data-aos-duration': animationDuration * 1000,
		// 'data-aos-easing':'ease-in-out',
		// 'data-aos-mirror':false,
		// 'data-aos-once':false,
		// 'data-aos-anchor-placement':'bottom-bottom'
	}


	return {
		className: isBackend ? `btnButton btnEditor` : `btnButton`,
		...linkProps,
		...tooltipProps,
		...animationProps,
		id: addID
	}
}